import type { LabelRecordMap } from '@libs/data-access/entities'
import { Anchor, Select } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import formStyles from '@spa/components/FormFields/styles/Form.module.css'
import { routes } from '@spa/core/router'
import React from 'react'
import type { FC } from 'react'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import { Link, createSearchParams, generatePath } from 'react-router-dom'

import { useDefaultLabel } from '../../ShiftForm/hooks/useDefaultLabel'
import {
  getLabelFormatted,
  NO_LABEL_VALUE
} from '../../ShiftForm/utils/getLabelFormatted'

type Props = {
  control?: Control<any>
  errors: FieldErrors
  disabled?: boolean
  haveAccess: boolean
  labels: LabelRecordMap
  selectedLocationId?: number
  setValue: Function
}
/**
 * @deprecated don't use it
 */
const LabelSelectLegacyComponent: FC<Props> = ({
  control,
  errors,
  disabled,
  haveAccess,
  labels,
  selectedLocationId,
  setValue
}) => {
  const { t } = usePlanningFormTranslation()
  const defaultLabel = useDefaultLabel()

  const labelOptions = labels
    .valueSeq()
    .sortBy(label => label?.name.toLowerCase())
    .map(label =>
      getLabelFormatted({
        value: label?.id.toString(),
        label: label?.name,
        color: label?.color
      })
    )
    .toJS()
  // We want the object (label, value, highlight), not just the number value
  const handleChange = (newValue: string) => {
    setValue(
      'label',
      labelOptions.find(option => option.value === newValue) ?? defaultLabel
    )
  }

  return (
    <div className={formStyles.FieldGroup}>
      <Controller
        name='label'
        control={control}
        render={({ field: { value } }) => (
          <Select
            clearable
            fillWidth
            className='mb-2'
            dropdownHeight='m'
            dropdownWidth='target'
            onChange={handleChange}
            options={[defaultLabel, ...labelOptions]}
            value={value.value.toString() || NO_LABEL_VALUE}
            disabled={disabled}
            errorMessage={formatErrors({
              inputName: 'label',
              errors
            })}
            footer={
              haveAccess &&
              !disabled && (
                <Anchor
                  component={Link}
                  rightIcon
                  className='text-xs no-underline'
                  to={{
                    search: createSearchParams({
                      tab: 'planification'
                    }).toString(),
                    pathname: generatePath(routes.settingsLocation.rootPath, {
                      id: selectedLocationId
                    })
                  }}
                  variant='primary'
                >
                  {t('component.labelField.link')}
                </Anchor>
              )
            }
            label={<>{t('component.labelField.title')}</>}
          />
        )}
      />
    </div>
  )
}

/**
 * @deprecated NOPE
 */
export const LabelSelectLegacy = React.memo(LabelSelectLegacyComponent)
